import { FaMobileAlt, FaCar, FaHeadset, FaTags } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaMobileAlt />, // Mobile icon
        title: 'Hassle-Free Booking',
        description: 'Reserve your car online in just a few clicks. Choose vehicle & set your dates.',
    },
    {
        id: 2,
        icon: <FaCar />, // Car icon
        title: 'Wide Vehicle Selection',
        description: 'From luxury to economy cars, we have a diverse fleet to match your needs.',
    },
    {
        id: 3,
        icon: <FaHeadset />, // Headset icon
        title: '24/7 Customer Support',
        description: 'Our support team is available round-the-clock to help with your bookings.',
    },
    {
        id: 4,
        icon: <FaTags />, // Tags icon
        title: 'Affordable Pricing',
        description: 'Enjoy competitive rates with no hidden charges, ensuring the best value for your money.',
    },
];

export default features;